<template>
    <file-manager-modal
            v-if="show"
            :size="size"
            :show="show"
            @file-manager-modal-close="close()">

        <div class="modal-header">
            <h4 class="modal-title">{{ t.__('Usuń element') }}</h4>
            <button type="button" class="close" @click="close()">&times;</button>
        </div>

        <div class="modal-body">
            <div class="form-group">
                <label>{{ t.__('Czy na pewno chcesz usunąć ten element?') }}</label>
                <p class="form-control-static">{{ getItemName(currentFile) }}</p>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary"
                    type="button"
                    :disabled="loading"
                    @click="deleteItem()">
                <template v-if="loading">{{ t.__('Usuwam...') }}</template>
                <template v-if="!loading">{{ t.__('Usuń') }}</template>
            </button>
            <button class="btn btn-light"
                    type="button"
                    :disabled="loading"
                    @click="close">
                {{ t.__('Anuluj') }}
            </button>
        </div>

    </file-manager-modal>
</template>

<script>

    import axios from "axios";
    import fileManagerMixin from "../../mixins/file-manager-mixin";

    export default {
        mixins: [fileManagerMixin],
        props: {
            currentPath: {
                default: '',
                type: String
            },
            currentFile: {
                default: function () {
                    return {};
                },
                type: [Object, Boolean]
            },
            show: {
                default: false,
                type: Boolean
            }
        },
        data: () => {
            return {
                loading: false,
                newItemName: null,
                size: 'modal-sm'
            };
        },
        mounted() {
            document.addEventListener('keydown', (e) => {
                if (this.show && e.keyCode === 13) {
                    this.deleteItem();
                }
            });
        },
        methods: {
            close() {
                this.newItemName = null;
                this.loading = false;
                this.$emit('file-manager-modal-close');
            },
            deleteItem(route, data) {
                if (this.isFolder(this.currentFile)) {
                    return this.deleteFolder(route, data);
                }
                return this.deleteFile(route, data);
            },
            deleteFile() {
                if (this.currentFile) {
                    const data = {
                        'path': this.currentFile.fullPath
                    };
                    this.rm(route('file-manager.delete-file'), data);
                }
            },
            deleteFolder() {
                if (this.isFolder(this.currentFile)) {
                    const data = {
                        'path': this.currentFile.fullPath
                    };
                    this.rm(route('file-manager.delete-folder'), data);
                }
            },
            rm(route, payload) {
                this.loading = true;
                axios.delete(route, {params: payload}).then(
                    (response) => {
                        this.$emit('reload-folder');
                        this.fileManagerNotify(response.data.message, 'success');
                        this.close();
                    },
                    (response) => {
                        const error = response.data.message;
                        this.fileManagerNotify(error, 'danger');
                        this.close();
                    }
                );
            }
        }
    };
</script>
